// import React, { useContext } from "react";
// // import Card from "../components/Card";
// import { ThemeContext } from "../themeProvider";
// import { githubstatus } from "../constants";
// import { motion } from "framer-motion";
// // import { techStack } from "../constants";
// import GitHubCalendar from 'react-github-calendar';

// const Githubstatus = () => {
//   const theme = useContext(ThemeContext);
//   const darkMode = theme.state.darkMode;

//   return (
//     <div
//       id="githubstatus"
//       className={darkMode ? "bg-gray-100 text-black" : "bg-gray-700"}
//     >
//       <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4  pt-24 pb-12">
//         <h2 className={darkMode? "text-5xl font-bold px-4 md:px-0 text-center": "text-5xl font-bold px-4 md:px-0 text-center text-white"}>
//         GITHUB STATUS
//         </h2>
//         {/* flex flex-wrap mt-8 flex flex-wrap justify-between  */}
//         <div
//           className=""
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             justifyContent: "space-between",
//           }}
//         >
//           {githubstatus.map((el) => (
//             <motion.div
//               initial="hidden"
//               whileInView={"visible"}
//               variants={{
//                 visible: {
//                   y: 0,
//                   opacity: 1,
//                   transition: {
//                     type: "spring",
//                   },
//                 },
//                 hidden: { opacity: 1, y: 80 },
//               }}
//               // md:w-48 w-40
//               className="py-2 px-4 bg-gray-50 md:m-2 mx-2 mt-3 rounded-lg  items-center hover:scale-125 cursor-pointer "
//             >
//               <img
//                 alt=""
//                 src={el.link}
//                 className="w-12"
//                 style={{ width: "100%", border: "1px solid green" }}
//               />
//               {/* <h4
//                 className=" ml-4"
//                 style={{
//                   color: "yellowgreen",
//                   fontWeight: "bold",
//                   textAlign: "center",
//                   fontSize: "28px",
//                 }}
//               >
//                 {el.name}
//               </h4> */}
//               {/* <p>{el.desc}</p> */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   margin: "20px",
//                 }}
//               >
//               </div>
//             </motion.div>
//           ))}
//         </div>
// <div>
// <GitHubCalendar username="Manojgum" />
// </div>

//       </div>
//     </div>
//   );
// };

// export default Githubstatus;



// import React, { useContext } from "react";
// import { ThemeContext } from "../themeProvider";
// import { githubstatus } from "../constants";
// import { motion } from "framer-motion";
// import GitHubCalendar from 'react-github-calendar';

// const Githubstatus = () => {
//   const theme = useContext(ThemeContext);
//   const darkMode = theme.state.darkMode;

//   return (
//     <div
//       id="githubstatus"
//       className={darkMode ? "bg-gray-100 text-black" : "bg-gray-700"}
//     >
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
//         <h2 className={darkMode ? "text-5xl font-bold text-center" : "text-5xl font-bold text-center text-white"}>
//           GITHUB STATUS
//         </h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4  mt-8">
//           {githubstatus.map((el) => (
//             <motion.div
//               key={el.name}
//               initial="hidden"
//               whileInView={"visible"}
//               variants={{
//                 visible: {
//                   y: 0,
//                   opacity: 1,
//                   transition: {
//                     type: "spring",
//                   },
//                 },
//                 hidden: { opacity: 1, y: 80 },
//               }}
//               className="py-2 px-4 bg-gray-50 md:m-2 mx-2 mt-3 rounded-lg items-center hover:scale-125 cursor-pointer"
//             >
//               <img
//                 alt=""
//                 src={el.link}
//                 className="w-12"
//                 style={{ width: "100%", border: "1px solid green" }}
//               />
//             </motion.div>
//           ))}
//         </div>
//         <div className="mx-auto mt-8"
//         style={{ maxWidth: "fit-content" }}
//         >
//           <GitHubCalendar username="Manojgum" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Githubstatus;


import React, { useContext } from "react";
import { ThemeContext } from "../themeProvider";
import { githubstatus } from "../constants";
import { motion } from "framer-motion";
import GitHubCalendar from 'react-github-calendar';

const Githubstatus = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      id="githubstatus"
      className={darkMode ? "bg-gray-100 text-black" : "bg-gray-700"}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
        <h2 className={darkMode ? "text-5xl font-bold text-center" : "text-5xl font-bold text-center text-white"}>
          GITHUB STATUS
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4  mt-8">
          {githubstatus.map((el) => (
            <motion.div
              key={el.name}
              initial="hidden"
              whileInView={"visible"}
              variants={{
                visible: {
                  y: 0,
                  opacity: 1,
                  transition: {
                    type: "spring",
                  },
                },
                hidden: { opacity: 1, y: 80 },
              }}
              className="py-2 px-4 bg-gray-50 md:m-2 mx-2 mt-3 rounded-lg items-center hover:scale-125 cursor-pointer"
            >
              <img
                alt=""
                src={el.link}
                className="w-12"
                style={{ width: "100%", border: "1px solid green" }}
              />
            </motion.div>
          ))}
        </div>
        {/* <div className="mx-auto mt-8"
          style={{ maxWidth: "fit-content" }}
        >
          <div className="w-full  mx-auto">
            <GitHubCalendar username="Manojgum" />
          </div>
        </div> */}

<div className=" mt-8 hidden md:block"
          style={{ maxWidth: "fit-content" }}
        >
          <div className="w-full  mx-auto">
            <GitHubCalendar username="Manojgum" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Githubstatus;

